let toFixed=(input,num)=>Number(input).toFixed(num)
 
export default {toFixed}//默认导出